import React, { useState, useEffect } from "react";
import _, { isArray } from "lodash";
import SaveIcon from "@mui/icons-material/SaveRounded";
import CloseIcon from "@mui/icons-material/CloseRounded";
import { Button, Modal, Row, Col } from "react-bootstrap";
import ApiAmusementService from "../../../core/api/api.amusementService";
import "../../pages/_Components/ReactBeautifulDnd.css";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import SwalMessage from "../_Components/SwalMessage";
import ApiAmusementServiceReserveItem from "../../../core/api/api.amusementServiceReserveItem";
import SelectComponent from "../_Components/ReactSelectComponent";

const ChangeOrderReserveItem = ({ showModalReserveItemOrder, setShowModalReserveItemOrder }) => {
  const [reserveItems, setReserveItems] = useState([]);
  const [amusementServiceId, setAmusementServiceId] = useState(null);
  const [services, setServices] = useState([]);
  const [formInputs, setFormInputs] = useState({});

  const selectStyles = {
    menu: (base) => ({
      ...base,
      zIndex: 10000,
    }),
  };
  // Fetch all services
  useEffect(() => {
    const fetchServices = async () => {
      try {
        const data = await ApiAmusementService.getAllServices();
        if (!_.isEmpty(data)) {
          setServices(data);
        }
      } catch (error) {
      }
    };

    fetchServices();
  }, []);
  const handleDragEnd = (result) => {
    if (!result.destination) return;

    const updatedReserveItems = Array.from(reserveItems);
    const [reorderedItem] = updatedReserveItems.splice(result.source.index, 1);
    updatedReserveItems.splice(result.destination.index, 0, reorderedItem);

    setReserveItems(updatedReserveItems);
  };
  const handleClose = () => {
    setShowModalReserveItemOrder(false);
  };
  const sendSortedReserveItems = async () => {
    try {
      // اطلاعات مورد نیاز برای ارسال به سرور
      const dataToSend = {
        reserveItems: reserveItems.map((item) => ({ id: item.id, title: item.title })),
      };
      // ارسال درخواست به سرور
      const response = await ApiAmusementServiceReserveItem.changeOrderAmusementServiceReserveItem(dataToSend);
      SwalMessage({ title: response.message, iSsuccess: true });
      setShowModalReserveItemOrder(false);
    } catch (error) {
    }
  };
  ///
  const handleServiceChange = (selectedOption) => {
    setAmusementServiceId(selectedOption?.value);
    inputChangeHandler2(selectedOption);
  };
  const inputChangeHandler2 = async (selectedOption) => {
    if (selectedOption && !isArray(selectedOption)) {
      const { type, value } = selectedOption;

      setFormInputs((prevState) => ({
        ...prevState,
        [type]: selectedOption,
      }));

      try {
        const amusementServiceReserveItems = await ApiAmusementServiceReserveItem.getAllReserveItems(value);
        if (!_.isEmpty(amusementServiceReserveItems)) {
          const activeItems = amusementServiceReserveItems.filter(a => a.isActive);
          setReserveItems(activeItems);
        }
      } catch (error) {
      }
    }
    else {
      setFormInputs(null)
      setReserveItems([])
    }
  };

  return (
    <div>
      <div className="card-body pt-3 pb-0">
        {/* Start Modal */}
        <Modal centered size="md" show={showModalReserveItemOrder} onHide={handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>ترتیب قرارگیری آیتم های رزرو در این سرویس</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Row>
              <Col xs="12" style={{ zIndex: "3" }}>
                <SelectComponent
                  name="service"
                  style={selectStyles}
                  inputId="react-select-with-search"
                  className="w-100 mt-2 mb-3"
                  variant="outlined"
                  size="small"
                  placeholder="انتخاب تفریح"
                  TextFieldProps={{
                    label: "Services2",
                    InputLabelProps: {
                      htmlFor: "react-select-multiple",
                      shrink: true,
                    },
                  }}
                  options={services?.map((item) => ({
                    value: item.id,
                    label: item.name,
                    type: "service",
                  }))}
                  value={formInputs?.service || ""}
                  onChange={handleServiceChange}
                />
              </Col>
            </Row>
            <DragDropContext onDragEnd={handleDragEnd}>
              <Droppable droppableId="droppable">
                {(provided) => (
                  <ul className="sortable-list" {...provided.droppableProps} ref={provided.innerRef}>
                    {reserveItems.map((item, index) => (
                      <Draggable key={item.id} draggableId={item.id.toString()} index={index}>
                        {(provided) => (
                          <li
                            className="sortable-item"
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                          >
                            <span>{item.title}</span>
                          </li>
                        )}
                      </Draggable>
                    ))}
                    {provided.placeholder}
                  </ul>
                )}
              </Droppable>
            </DragDropContext>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="success" onClick={sendSortedReserveItems}>
              <SaveIcon /> ذخیره
            </Button>
            <Button variant="danger" onClick={handleClose}>
              <CloseIcon /> بستن
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </div>
  );
};
export default ChangeOrderReserveItem;
